import React from 'react';
import { Typography } from '@mui/material';

import type { IntakeStatusNote } from '@shared/patient-intake-status';

import { useGetNote } from '../hooks';
import { Note } from './Note.tsx';

interface NoteDisplayWithoutContextProps extends Omit<React.ComponentProps<typeof Note>, 'children' | 'visibility'> {
  patientId: string;
  stepId: string | null;
  isHealthcareProvider: boolean;
  noteConfig: Pick<IntakeStatusNote, 'id' | 'visibility'> | null;
  prefix?: string;
}

export const NoteDisplayWithoutContext: React.FC<NoteDisplayWithoutContextProps> = ({
  stepId,
  noteConfig,
  prefix,
  isHealthcareProvider,
  patientId,
  ...props
}) => {
  const { note, isLoading } = useGetNote({ patientId, stepId, noteConfig });

  if (isLoading || !note) {
    return null;
  }

  if (!isHealthcareProvider && !note.visibility.isVisibleToPatient) {
    return null;
  }

  if (isHealthcareProvider) {
    return (
      <Note visibility={note.visibility} {...props}>
        <Typography variant="body2" className="ph-no-capture">
          {prefix ? `${prefix}:` : ''} {note.content}
        </Typography>
      </Note>
    );
  }

  return (
    <Note visibility={null} {...props}>
      <Typography variant="body2" className="ph-no-capture">
        {prefix ? `${prefix}:` : ''} {note.content}
      </Typography>
    </Note>
  );
};
